import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { LanguageSelector } from "./LanguageSelector";
import { useLanguage } from "@/hooks/useLanguage";
import { Logo } from "./Logo";
import { LogIn } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

export const Hero = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const isMobile = useIsMobile();

  const handleNavigateToAuth = () => {
    // Check for stored referral code
    const refCode = localStorage.getItem('referralCode');
    if (refCode) {
      navigate(`/auth?ref=${refCode}`);
    } else {
      navigate("/auth");
    }
  };

  return (
    <div className="relative min-h-[80vh] bg-gradient-to-br from-[#1A1F2C] to-[#7E69AB] flex flex-col">
      {/* Background image */}
      <div className="absolute inset-0 bg-[url('/background.webp')] bg-cover bg-center opacity-10"></div>
      
      {/* Header section with language selector and sign in - now a regular flex container */}
      <div className="relative z-20 w-full p-4 flex justify-end items-center gap-2">
        <LanguageSelector />
        <Button
          onClick={handleNavigateToAuth}
          variant="secondary"
          className="bg-white/20 border-2 border-white text-white hover:bg-white/30 font-semibold transition-all"
        >
          <LogIn style={isMobile ? {width: '24px', height: '24px', minWidth: '24px'} : undefined} />
          {t('landing.hero.signIn')}
        </Button>
      </div>
      
      {/* Main content area */}
      <div className="flex-grow container mx-auto px-4 text-center relative z-10 flex flex-col items-center justify-center py-4">
        <div className="flex justify-center mb-8 mt-4">
          <Logo size="lg" className="text-[#7E69AB]" />
        </div>
        <div className="space-y-2 mb-6">
          <h1 className="text-4xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#7E69AB] to-[#6E59A5]">
            {t('landing.hero.title')}
          </h1>
          <p className="text-2xl md:text-4xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#7E69AB] to-[#6E59A5]">
            {t('landing.hero.subtitle')}
          </p>
        </div>
        <div className="my-8">
          <p className="text-lg md:text-xl lg:text-2xl text-gray-300 opacity-0 animate-fade-in">
            {t('landing.hero.description')}
          </p>
        </div>
        <Button 
          onClick={handleNavigateToAuth}
          className="bg-[#7E69AB] hover:bg-[#6E59A5] text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all"
        >
          {t('landing.hero.startStory')}
        </Button>
      </div>
    </div>
  );
};
